import React, {lazy, Suspense} from 'react'

const CatholicHouseholdPageLazy = lazy(() =>
    import('./CatholicHouseholdPage')
)

const CatholicHouseholdPage = props => (
    <Suspense fallback={null}>
        <CatholicHouseholdPageLazy {...props} />
    </Suspense>
)

export default CatholicHouseholdPage
